import React from 'react'
import { useTranslation } from 'react-i18next'
import * as R from 'remeda'

import {
  RedirectOrError,
  type RedirectOrErrorProps,
} from '~/components/features/RedirectOrError'
import { useAvailableApplications } from '~/hooks/useAvailableApplications'
import { exists } from '~/utils'

export const PrivateTopPage = () => {
  const { t } = useTranslation()
  const applications = useAvailableApplications()
  const getRedirectPath = React.useCallback<
    RedirectOrErrorProps['getRedirectPath']
  >(() => {
    const primaryApplication = R.first(applications)

    if (!exists(primaryApplication)) {
      return {
        success: false,
        error: t('cannot_be_used_because_setup_is_not_complete_3'),
      }
    }

    return { success: true, path: primaryApplication.rootPath }
  }, [applications, t])

  return <RedirectOrError getRedirectPath={getRedirectPath} />
}
